export const isAgentPlatformEnabled = (value = process.env.REACT_APP_AGENT_PLATFORM_ENABLED): boolean =>
  String(value || '').trim().toLowerCase() === 'true';

export const isAgentPlatformGoogleEnabled = (
  value = process.env.REACT_APP_AGENT_PLATFORM_GOOGLE_CONNECTIONS_ENABLED,
): boolean => String(value || '').trim().toLowerCase() === 'true';

/** Local API access is deliberately opt-in and never enables a remote origin. */
export const isAgentPlatformLocalEnabled = (
  value = process.env.REACT_APP_AGENT_PLATFORM_LOCAL_ENABLED,
): boolean => String(value || '').trim().toLowerCase() === 'true';
